import { ClipboardCopy } from './clipboard-copy.js';

ClipboardCopy.defineCustomElement();

export { ClipboardCopy };
